import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import {
  ConfirmationPayload,
  MultiSelectPayload,
  SelectPayload,
  PayloadItem,
  TextPayload,
  OrderSummaryPayload,
  TimeSlotPayload,
  LinkPayload,
} from '../../interfaces';
import {
  ConfirmationPayloadComponent,
  MultiselectPayloadComponent,
  SelectPayloadComponent,
  TextPayloadComponent,
  OrderSummaryPayloadComponent,
  TimeSlotPayloadComponent,
  LinkPayloadComponent,
} from '../../payloads';

@Component({
  selector: 'bevvi-payload-renderer',
  imports: [
    TextPayloadComponent,
    SelectPayloadComponent,
    MultiselectPayloadComponent,
    ConfirmationPayloadComponent,
    OrderSummaryPayloadComponent,
    TimeSlotPayloadComponent,
    LinkPayloadComponent,
  ],
  templateUrl: './payload-renderer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayloadRenderer {
  public readonly payload = input.required<PayloadItem>();
  public readonly disabled = input(false);

  public readonly userReply = output<string>();

  protected readonly textPayload = computed((): TextPayload | null =>
    this.payload().type === 'text' ? (this.payload().data as TextPayload) : null,
  );

  protected readonly confirmationPayload = computed((): ConfirmationPayload | null =>
    this.payload().type === 'confirmation' ? (this.payload().data as ConfirmationPayload) : null,
  );

  protected readonly selectPayload = computed((): SelectPayload | null =>
    this.payload().type === 'select' ? (this.payload().data as SelectPayload) : null,
  );

  protected readonly multiselectPayload = computed((): MultiSelectPayload | null =>
    this.payload().type === 'multiselect' ? (this.payload().data as MultiSelectPayload) : null,
  );

  protected readonly orderSummaryPayload = computed((): OrderSummaryPayload | null =>
    this.payload().type === 'order-summary' ? (this.payload().data as OrderSummaryPayload) : null,
  );

  protected readonly timeSlotPayload = computed((): TimeSlotPayload | null =>
    this.payload().type === 'time-slot' ? (this.payload().data as TimeSlotPayload) : null,
  );

  protected readonly linkPayload = computed((): LinkPayload | null =>
    this.payload().type === 'link' ? (this.payload().data as LinkPayload) : null,
  );
}
